import type { NextPage, GetStaticProps } from "next";
import { ProvisionalRegistrationPage } from "@/components/pages/ProvisionalRegistrationPage";
import useFixedAuth from "@/libs/useFixedAuth";
import useCheckAuth from "@/libs/useCheckAuth";
import { useRollbarContext } from "@rollbar/react";
import config from "@/libs/config";
import { ErrorPage } from "@/components/pages";
import { ErrorCode } from "@/libs/errors";

const ProvisionalRegistration: NextPage = () => {
  useRollbarContext("provisional-registration");

  const { authStatus } = useFixedAuth();

  useCheckAuth({ authStatus, redirectToIfSignedIn: "/select-service" });

  if (config.IS_SHIKOKUBANK) {
    return (
      <ErrorPage code={ErrorCode.BIZSOL_USER_IS_NOT_ALLOWED_TO_BE_REGISTERED} />
    );
  }

  return <ProvisionalRegistrationPage />;
};

export default ProvisionalRegistration;

export const getStaticProps: GetStaticProps = async () => {
  const posts = {};
  return {
    props: { posts },
  };
};
